import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Add this line
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.scss';
import './styles/responsive.scss';
import './styles/mobileSpecific.scss';
import App from './App';
import { PortProvider } from './service/MessageChannelContext';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <PortProvider>
        <App />
      </PortProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();
